exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.single-table .table thead th {\n  border-bottom: none !important;\n  color: #80a5b9;\n  padding-bottom: 2rem !important;\n}\ndiv.single-table .table tbody tr {\n  color: #052738;\n  font-weight: 500;\n  line-height: 1.5;\n}\ndiv.single-table .table tbody tr:nth-child(odd) {\n  background-color: #dae2e8;\n}", ""]);

// exports
